<template>
  <ListingBlock
    class="listing-block--books"
    :view="view"
    :docs="view.docs().filteredDocs.slice(0, 3)"
    :cardProps="{ mobileVariant: 'vertical' }"
  />
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'
import { ListView } from '@/models/docs.list'

defineProps<{
  view: ListView
}>()
</script>
